import React, { useEffect, useState } from "react";

const pad = (n) => String(n).padStart(2, "0");

const getRemaining = (end) => {
  const diff = Math.max(0, end.getTime() - Date.now());
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hrs = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const min = Math.floor((diff / (1000 * 60)) % 60);
  const sec = Math.floor((diff / 1000) % 60);
  return { days, hrs, min, sec };
};

const Unit = ({ value, label }) => (
  <div className="flex flex-col items-center">
    <div className="relative flex h-16 w-16 sm:h-20 sm:w-20 items-center justify-center rounded-2xl glass overflow-hidden">
      <span className="font-display text-2xl sm:text-3xl font-bold text-white tabular-nums">
        {pad(value)}
      </span>
      <span className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-emerald-400/50 to-transparent" />
    </div>
    <span className="mt-2 text-[10px] sm:text-xs uppercase tracking-widest text-slate-500">
      {label}
    </span>
  </div>
);

const Countdown = ({ end }) => {
  const [t, setT] = useState(() => getRemaining(end));

  useEffect(() => {
    const id = setInterval(() => setT(getRemaining(end)), 1000);
    return () => clearInterval(id);
  }, [end]);

  return (
    <div className="flex flex-col items-center gap-3">
      <p className="text-xs uppercase tracking-[0.25em] text-emerald-300/80">
        Competition ends in
      </p>
      <div className="flex items-center gap-2 sm:gap-3">
        <Unit value={t.days} label="Days" />
        <span className="text-emerald-400/50 text-2xl font-bold pb-6">:</span>
        <Unit value={t.hrs} label="Hrs" />
        <span className="text-emerald-400/50 text-2xl font-bold pb-6">:</span>
        <Unit value={t.min} label="Min" />
        <span className="text-emerald-400/50 text-2xl font-bold pb-6">:</span>
        <Unit value={t.sec} label="Sec" />
      </div>
    </div>
  );
};

export default Countdown;
